import { useAppStore } from "@/global/store";
import { selectUser } from "@/global/store/data/user";
import {
  Box,
  Divider,
  Link,
  ListItemIcon,
  ListItemText,
  MenuItem,
  MenuList,
} from "@mui/material";
import { HiOutlineTicket } from "react-icons/hi";
import { MdOutlineEventSeat, MdOutlinedFlag } from "react-icons/md";
import { TbShirtSport } from "react-icons/tb";
import OpenInNewRoundedIcon from "@mui/icons-material/OpenInNewRounded";

export const purchaseSeatsLanguages = {
  // standard one
  // progressBarSuccessAditionalText:
  // "Select 10 games and get additional savings!",
  similarSeatModalBody: (seatTitle: string) => {
    return <>We are going to apply this selection to all games in your plan.</>;
  },
  // temporary one
  progressBarText: "Add 3 games and get 5% off your tickets",
};

// standard one
// export const howItWorks = [
//   {
//     icon: <MdOutlinedFlag />,
//     title: "Choose Your Games",
//     description: "Select the games you wish to attend.",
//   },
//   {
//     icon: <MdOutlineEventSeat />,
//     title: "Login to Account Manager",
//     description:
//       " Click Continue and connect your Detroit Pistons account using our secure Ticketmaster login.",
//   },
//   {
//     icon: <TbShirtSport />,
//     title: "Select Your Seats",
//     description: "Select the seats you wish to purchase for each game.",
//   },

//   {
//     icon: <HiOutlineTicket />,
//     title: "Get Your Tickets",
//     description:
//       "Tickets will be available in your Account Manager within 24 hours of redemption. Reach out to Live Fan Support for any questions.",
//   },
// ];

// export const faqs = [
//   {
//     title: "How does the Pistons Flex program work?",
//     description:
//       "The Pistons Flex program allows fans to select any seat to any game. Simply log into your Pistons Account manager and select games.",
//   },
//   {
//     title:
//       "What additional benefits do I get through the Pistons Flex program?",
//     description: (
//       <>
//         Over 15% savings per game
//         <br />
//         <br />
//         10% off all Merchandise at the Pistons 313 Shop Online
//         <br />
//         <br />
//         Access to Pistons One Rewards
//         <br />
//         <br />
//         Guaranteed Playoff Priority (Access to purchase a strip)
//         <br />
//         <br />
//         25-26 Membership Priority
//         <br />
//         <br />
//         Complimentary tickets to the TBD December 2024 game (game details and
//         seat locations to be shared at a later date)
//       </>
//     ),
//   },
//   {
//     title: "Do I have to select all my games now?",
//     description:
//       "Yes, you must select all the games you'd like to attend throughout the season in one transaction.",
//   },
//   {
//     title: "Can I choose seats throughout the venue?",
//     description: "Yes, you can choose from all current available inventory.",
//   },
//   {
//     title: "Where are event tickets delivered?",
//     description:
//       "Event tickets are delivered directly within your Pistons Account Manager within an hour of selection.",
//   },
// ];

// temporary one
export const howItWorks = [
  {
    icon: <MdOutlinedFlag />,
    title: "Choose Your Games",
    description: "Select the games you wish to attend.",
  },
  {
    icon: <MdOutlineEventSeat />,
    title: "Login to Account Manager",
    description:
      "Click Continue and connect your Detroit Pistons using our secure Ticketmaster login.",
  },
  {
    icon: <TbShirtSport />,
    title: "Select Your Seats",
    description: "Select the seats you wish to purchase for each game.",
  },

  {
    icon: <HiOutlineTicket />,
    title: "Get Your Tickets",
    description:
      "Tickets will be available in your Account Manager within 24 hours of purchase. Reach out to LIve Fan Support for any questions.",
  },
];

export const faqs = [
  {
    title: "How does the Pistons 3 Game Push To The Playoffs Plan work?",
    description:
      "The Pistons 3 Game Push To The Playoffs Plan allows fans to select any seat for 3 games.  Simply log into your Pistons Account manager and select games.",
  },
  {
    title:
      "What additional benefits do I get through the Pistons 3 Game Push To The Playoffs Plan?",
    description:
      "At least 5% savings per game you will receive guaranteed access to any 2025 NBA Playoff ticket presales when seats become available",
  },
  {
    title: "Do I have to select all my games now?",
    description:
      "Yes, you must select all the games you'd like to attend throughout the season in one transaction.",
  },
  {
    title: "Can I choose seats throughout the venue?",
    description: "Yes, you can choose from all currently available inventory.",
  },
  {
    title: "Where are my tickets delivered?",
    description:
      "Tickets are delivered directly within your Detroit Pistons Account Manager.",
  },
];

export function CheckoutTerms() {
  return (
    <>
      By purchasing you agree to receive SMS alerts regarding ticket delivery
      and agree to the{" "}
      <Link
        href={
          "https://uploads-ssl.webflow.com/5ed7df6fe67e862e0a62f9f2/616882d2b691e09f75348396_Terms%20%26%20Conditions.pdf"
        }
        target={"_blank"}
        sx={{
          color: "primary.main",
          textDecoration: "none",
          fontWeight: 500,
        }}
      >
        Terms & Conditions
      </Link>{" "}
      and{" "}
      <Link
        href={
          "https://uploads-ssl.webflow.com/5ed7df6fe67e862e0a62f9f2/63c05d80816dac05b5b34ac7_seasonshare%20CCPA%20Privacy%20Policy%20Agreement.pdf"
        }
        target={"_blank"}
        sx={{
          color: "primary.main",
          textDecoration: "none",
          fontWeight: 500,
        }}
      >
        Privacy Policy
      </Link>
      .
    </>
  );
}

export function TopNavMenuItems() {
  const user = useAppStore(selectUser);

  return (
    <Box>
      {user ? <Divider /> : null}
      <MenuList>
        <MenuItem
          onClick={() => {
            window.open("https://forms.pistons.com/1450", "_blank");
          }}
        >
          <ListItemIcon>
            <OpenInNewRoundedIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Speak To A Representative</ListItemText>
        </MenuItem>
      </MenuList>
    </Box>
  );
}
